var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"query-c"},[_vm._v("\n        查询：\n        "),_c('Input',{staticStyle:{"width":"auto"},attrs:{"search":"","placeholder":"请输入查询内容"}})],1),_c('br'),_c('Table',{attrs:{"border":"","stripe":"","columns":_vm.columns1,"data":_vm.data1}}),_c('br'),_c('Page',{attrs:{"total":100,"show-sizer":"","show-elevator":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }